<template>
  <div class="account-agreement-sign view">
    <Card class="account-agreement-sign__widget">
      <template #header>
        <FontAwesomeIcon :icon="['fal', 'lock']" size="2x" />
        <h1>{{ $t('contractMustBeSignedHeader') }}</h1>
      </template>
      <template #default>
        <div class="text--center">
          <p>{{ $t('contractMustBeSignedDescription') }}</p>
          <ButtonComponent
            class="account-agreement-sign__link"
            :icon="['fal', 'external-link']"
            icon-placement="left"
            theme="primary"
            tag="a"
            v-on:click.stop="() => ({})"
            :href="url"
          >
            <template #label>
              {{ $t('gotoSigning') }}
            </template>
          </ButtonComponent>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import Card from '@/components/Card'

export default {
  computed: {
    url() {
      const data = sessionStorage.getItem('accountAgreementData')
      return data ? `https://${JSON.parse(data).url}` : ''
    },
  },
  metaInfo() {
    return {
      title: this.$t('contractMustBeSignedHeader'),
    }
  },
  components: {
    Card,
  },
}
</script>

<style lang="scss">
.account-agreement-sign {
  background-color: $background-grey;
  display: flex;
  justify-content: center;
  align-items: center;

  h1 {
    margin: 1rem 0 0 0;
    font-size: 1.5rem;
  }

  &__widget {
    flex-grow: 1;
    max-width: 400px;
  }
}
</style>
